import styled from 'styled-components';

// Cores dinâmicas do tema
const colors = {
  primary: '#122D58', // Azul escuro
  secondary: '#FFF28D', // Amarelo (mesma cor do botão Importar Múltiplos XMLs)
  lightBlue: '#4FC3F7', // Azul claro
  background: '#F5F5F5',
  white: '#FFFFFF',
  gray: '#E0E0E0',
  darkGray: '#666666',
  text: '#333333',
  success: '#4CAF50',
  error: '#F44336',
};

export const Container = styled.div`
  padding: 0;
  width: 100%;
  background-color: ${colors.background};
  min-height: 100vh;
`;

export const ModalContainer = styled.div`
  max-width: 1200px;
  margin: 20px auto;
  background: ${colors.white};
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
`;

export const ModalHeader = styled.div`
  background-color: ${colors.primary};
  color: ${colors.white};
  padding: 16px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ModalTitle = styled.h2`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: ${colors.white};
`;

export const HeaderButtons = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const HeaderSaveButton = styled.button`
  padding: 8px 20px;
  background-color: ${colors.secondary};
  color: ${colors.primary};
  border: none;
  border-radius: 3px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  
  &:hover {
    background-color: #FFEB3B;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(255, 242, 141, 0.3);
  }
`;

export const HeaderCancelButton = styled.button`
  padding: 8px 20px;
  background-color: transparent;
  color: ${colors.white};
  border: 1px solid ${colors.white};
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
`;

export const StepsContainer = styled.div`
  display: flex;
  background-color: ${colors.white};
  border-bottom: 1px solid ${colors.gray};
  padding: 0 24px;
`;

export const Step = styled.div`
  padding: 16px 24px;
  cursor: pointer;
  border-bottom: 3px solid transparent;
  transition: all 0.3s ease;
  color: ${props => props.active ? colors.primary : colors.darkGray};
  font-weight: ${props => props.active ? '600' : '400'};
  border-bottom-color: ${props => props.active ? colors.secondary : 'transparent'};
  background-color: ${props => props.active ? 'rgba(255, 242, 141, 0.1)' : 'transparent'};
  
  &:hover {
    background-color: ${props => props.active ? 'rgba(255, 242, 141, 0.1)' : 'rgba(0, 0, 0, 0.05)'};
  }
`;

export const StepNumber = styled.span`
  font-weight: 700;
  margin-right: 8px;
  color: ${props => props.active ? colors.primary : colors.darkGray};
`;

export const FormContent = styled.div`
  padding: 24px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  
  @media (max-width: 968px) {
    grid-template-columns: 1fr;
  }
`;

export const LeftPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const RightPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SectionTitle = styled.h3`
  font-size: 14px;
  font-weight: 600;
  color: ${colors.primary};
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const WrapperInput = styled.div`
  margin-bottom: 0;
`;

export const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background-color: ${colors.background};
  border-radius: 4px;
`;

export const ToggleLabel = styled.span`
  font-size: 14px;
  color: ${colors.text};
  font-weight: 500;
`;

export const ChipsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  padding: 16px;
  background-color: ${colors.background};
  border-radius: 4px;
  min-height: 60px;
`;

export const Chip = styled.button`
  padding: 8px 16px;
  border: none;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: ${props => props.selected ? colors.primary : colors.lightBlue};
  color: ${colors.white};
  
  &:hover {
    opacity: 0.9;
    transform: translateY(-2px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

export const CompaniesSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  background-color: ${colors.background};
  border-radius: 4px;
`;

export const CompanyCheckbox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  border-radius: 4px;
  
  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
`;

export const SearchButton = styled.button`
  padding: 8px 12px;
  border: 1px solid ${colors.primary};
  border-radius: 4px;
  background-color: ${colors.white};
  color: ${colors.primary};
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  
  &:hover {
    background-color: ${colors.primary};
    color: ${colors.white};
  }
`;

export const PermissionsSection = styled.div`
  margin-top: 24px;
  background-color: ${colors.white};
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
`;

export const PermissionsHeader = styled.div`
  background-color: ${colors.primary};
  color: ${colors.white};
  padding: 16px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
`;

export const PermissionsTitle = styled.h3`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: ${colors.white};
`;

export const PermissionsTableHeader = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr 1fr 1fr;
  gap: 16px;
  padding: 16px 24px;
  background-color: ${colors.background};
  border-bottom: 2px solid ${colors.gray};
  font-weight: 600;
  font-size: 14px;
  color: ${colors.primary};
`;

export const PermissionsTableRow = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr 1fr 1fr;
  gap: 16px;
  padding: 16px 24px;
  border-bottom: 1px solid ${colors.gray};
  align-items: center;
  transition: background-color 0.2s ease;
  
  &:hover {
    background-color: ${colors.background};
  }
  
  &:last-child {
    border-bottom: none;
  }
`;

export const PermissionsTableCell = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  color: ${colors.text};
`;

export const PermissionsTableActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const SelectAllContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const SearchIconContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  color: ${colors.primary};
  
  &:hover {
    opacity: 0.7;
  }
`;

export const ModalFooter = styled.div`
  padding: 16px 24px;
  background-color: ${colors.background};
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  border-top: 1px solid ${colors.gray};
`;

export const SaveButton = styled.button`
  padding: 10px 24px;
  background-color: ${colors.secondary};
  color: ${colors.primary};
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  
  &:hover {
    background-color: #FFEB3B;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(255, 242, 141, 0.3);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

export const CancelButton = styled.button`
  padding: 10px 24px;
  background-color: ${colors.gray};
  color: ${colors.text};
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: #BDBDBD;
    color: ${colors.white};
  }
`;
